<template>
    <el-card
        class="quality-item"
        shadow="nerver"
    >
        <template
            v-if="otherQualificationCertType"
        >
            <xx-form-item
                label-width="100px"
                label="证件类型"
                :prop="`items.${index}.qualificationType`"
                :rules="rules.qualificationType"
            >
                <mc-select
                    v-model="item.qualificationType"
                    :source="qualificationCertList"
                    filterable
                    :disabled-ids="disabledIds"
                />
            </xx-form-item>
        </template>
        <template v-if="!onlyShowPic">
            <xx-form-item
                label-width="110px"
                label="资质有效期"
                :prop="`items.${index}.longTerm`"
                :rules="rules.longTerm"
            >
                <el-radio-group
                    v-model="item.longTerm"
                    :disabled="MixinJudgeRejectedAttrsDisabled(item.rejectedDisabledAttr, item.longTerm, needValid, `${item.rejectedDisabledAttr}-${pIdx}-${index}-longTerm`)"
                    @change="onValidChange"
                >
                    <el-radio :label="true">
                        长期有效
                    </el-radio>
                    <el-radio :label="false">
                        非长期有效
                    </el-radio>
                </el-radio-group>
                <!-- 根据资质规则，使用新老日期交互：如果配置规则，则仅可以选择开始时间，结束时间不可编辑 -->
                <template v-if="periodRuleCom">
                    <span v-if="!item.longTerm">
                        <el-date-picker
                            v-model="date[0]"
                            type="date"
                            placeholder="开始日期"
                            value-format="timestamp"
                            :disabled="MixinJudgeRejectedAttrsDisabled(item.rejectedDisabledAttr, item.validTimeStart, needValid, `${item.rejectedDisabledAttr}-${pIdx}-${index}-date`)"
                            @change="onDateChange"
                        />
                        至
                        <span>
                            {{ getEndTime.str }}
                        </span>
                        <div class="el-form-item__description">截止日期系统自动填写</div>
                    </span>
                </template>
                <template v-else>
                    <el-date-picker
                        v-if="!item.longTerm"
                        v-model="date"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="timestamp"
                        :disabled="MixinJudgeRejectedAttrsDisabled(item.rejectedDisabledAttr, item.validTimeStart, needValid, `${item.rejectedDisabledAttr}-${pIdx}-${index}-date`)"
                        @change="onDateChange"
                    />
                </template>
            </xx-form-item>
        </template>
        <template
            v-if="otherQualificationCertType"
        >
            <xx-form-item
                label-width="100px"
                label="编号"
                :prop="`items.${index}.idNumber`"
                class="is-required hide-required-star"
            >
                <mc-input
                    v-model="item.idNumber"
                />
            </xx-form-item>
        </template>
        <xx-form-item
            label-width="110px"
            label="资质图片"
            :prop="`items.${index}.pictures`"
            :rules="rules.pictures"
        >
            <xn-upload
                ref="upload"
                v-model="pictureCom"
                class="form-upload"
                bucket-name="mall-fe-files"
                list-type="picture-card"
                :accept="accept"
                :action="action"
                upload-text="上传"
                :limit="40"
                :file-size="20"
                mul-preview
                :disabled="MixinJudgeRejectedAttrsDisabled(item.rejectedDisabledAttr, pictureCom, needValid, `${item.rejectedDisabledAttr}-${pIdx}-${index}-pictures`)"
            />
            <div
                v-if="item.desc"
                class="el-form-item__description"
                v-html="item.desc"
            >
            </div>
            <div
                v-if="currentDesc"
                class="el-form-item__description"
                v-html="currentDesc"
            ></div>
            <example-pic :type="exampleType" />
        </xx-form-item>
        <!-- 删除资质按钮 -->
        <mc-button
            v-if="otherQualificationCertType"
            type="danger"
            style="margin-bottom: 16px;"
            @click="removeQualificationType"
        >
            删除资质
        </mc-button>
    </el-card>
</template>

<script>
import Rules from '@lsfe/rules';
import MixinJudgeRejectedAttrsDisabled from '../mixins/rejectedDisabled';
import ExamplePic from '../components/ExamplePicDialog';
import { shared } from '../shareState';

/**
 * 暂时不使用这个判断逻辑，而采用全部禁用，不区分小字段
 * 驳回后，资质字段的禁用逻辑：
 * 白名单，仅能编辑资质图；
 * 黑名单，仅不能编辑资质图；
 *              白名单  黑名单
 * 【资质编号】   ❌     ✅
 * 【有效期】     ❌     ✅
 * 【资质图】     ✅     ❌
 */


const exampleMap = {
    13: 'checkReport',
    14: 'realPic',
    15: 'baoguandan',
    16: 'baoguandan',
    18: 'saleAuthorization', // 销售授权书
    1: 'businessLicense', // 营业执照
    6: 'productionLicense', // 生产许可证
    24: 'trademarkRegistration', // 商标注册证书
};
// 进口商品固定展示的资质类型（不显示删除按钮和证件类型选择）
const importOtherQualificationCertMap = {
    14: 'realPic', // 实物图
    15: 'baoguandan', // 商品报关单
    16: 'entryProve', // 入境检疫证明
};

// 非进口商品固定展示的资质类型（不显示删除按钮和证件类型选择）
const noImportOtherQualificationCertMap = {
    13: 'checkReport', // 商品检测报告
    14: 'realPic', // 实物图
};

export default {
    name: 'QualificationItem',
    components: {
        ExamplePic,
    },
    mixins: [MixinJudgeRejectedAttrsDisabled],
    props: {
        // 禁用的资质类型
        disabledIds: {
            type: Array,
            default: () => [],
        },
        qualificationCertList: {
            type: Array,
            default: () => ([]),
        },
        pIdx: {
            type: Number,
            default: 0,
        },
        index: {
            type: Number,
            default: 0,
        },
        item: {
            type: Object,
            default: () => ({}),
        },
        accept: {
            type: String,
            default: 'image/jpeg, image/png, image/jpg, image/gif, .pdf, .ppt, .rar, .zip',
        },
        needValid: {
            type: Boolean,
            default: true,
        },
        // 是否为进口商品（用于区分显示不同的固定资质类型）
        isImportFlag: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        const { needValid } = this;
        return {
            action: `${window.location.origin}/api/upload/picture.ajax`,
            date: [],
            radioOption: [
                {
                    label: '长期有效',
                    value: true,
                },
                {
                    label: '非长期有效',
                    value: false,
                },
            ],
            rules: needValid ? {
                pictures: [
                    Rules.lenRange({ min: 1 }, '请至少一张图片'),
                ],
                longTerm: [
                    Rules.isRequired('必填'),
                ],
                date: [
                    Rules.isRequired('必填'),
                ],
                qualificationType: [
                    Rules.isRequired('必填'),
                ],
            } : {},
        };
    },
    computed: {
        // 根据是否进口动态获取固定资质类型映射
        otherQualificationCertMap() {
            return this.isImportFlag ? importOtherQualificationCertMap : noImportOtherQualificationCertMap;
        },
        currentDesc() {
            // qualificationCertList 通过 prop 传入
            const type = this.item.qualificationType;
            // 如果是固定资质类型且已有 item.desc，则不显示 currentDesc，避免重复
            if (this.item.desc && Object.keys(this.otherQualificationCertMap).map(Number).includes(Number(type))) {
                return '';
            }
            const found = (this.qualificationCertList || []).find((opt) => opt.value === type);
            return found ? found.desc : '';
        },
        // 是否为其他证件类型
        otherQualificationCertType() {
            const type = Number(this.item.qualificationType);
            return !Object.keys(this.otherQualificationCertMap).map(Number).includes(type);
        },
        // 是否只展示资质图片，只有 实物图需要
        onlyShowPic() {
            return +this.item.qualificationType === 14;
        },
        pictureCom: {
            get() {
                return this.item.pictures ? this.item.pictures.map((pic) => pic.picUrl) : [];
            },
            set(val) {
                if (val && val.length) {
                    this.item.pictures = val.map((picUrl) => ({
                        picUrl,
                    }));
                } else {
                    this.item.pictures = [];
                }
            },
        },
        exampleType() {
            return exampleMap[+this.item.qualificationType];
        },
        periodRuleCom() {
            return this.getPeriodRule(this.item.qualificationType);
        },
        getEndTime() {
            if (!this.date[0]) return { str: '--', timestamp: null };
            const start = this.date[0];
            const { year, day } = this.periodRuleCom;
            const endTime = start + year * 365 * 24 * 60 * 60 * 1000 + day * 24 * 60 * 60 * 1000;
            return {
                str: this.$tools.formatTime(endTime, 'yyyy-MM-dd'),
                timestamp: endTime,
            };
        },
        validTime() {
            if (!this.item) return null;
            return [this.item.validTimeStart, this.item.validTimeEnd];
        },
    },
    watch: {
        validTime: {
            handler(val) {
                if (!val) return;
                const [validTimeStart, validTimeEnd] = val;
                if (validTimeStart > 0 || validTimeEnd > 0) {
                    this.date = [validTimeStart, validTimeEnd];
                }
                if (validTimeStart < 1 || validTimeEnd < 1) {
                    this.date = [];
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        removeQualificationType() {
            // 通知父组件删除当前项
            this.$emit('remove', this.index);
        },
        onDateChange(val) {
            let date;
            if (val) {
                // 兼容资质时间规则的结构
                if (this.periodRuleCom) {
                    date = [val, this.getEndTime.timestamp];
                } else {
                    date = val;
                }
            } else {
                date = [null, null];
            }
            this.item.validTimeStart = date[0];
            this.item.validTimeEnd = date[1];
        },
        onValidChange(val) {
            if (val) {
                this.item.validTimeStart = -1;
                this.item.validTimeEnd = -1;
            } else {
                this.item.validTimeStart = null;
                this.item.validTimeEnd = null;
            }
            this.date = [];
        },
        // 资质有效期是否配置规则，如果配置了，则截止日期不可以编辑；未配置则正常
        getPeriodRule(type) {
            const { categoryConfig: { flowSpec: { licenseValidPeriodRule } } } = shared;
            if (!licenseValidPeriodRule || !licenseValidPeriodRule.length) return false;
            const target = licenseValidPeriodRule.find((item) => item.licenseType === type);
            if (!target) return false;
            return target.rule;
        },
    },
};
</script>

<style scoped lang="scss">
/deep/ .hide-required-star .el-form-item__label:before {
  display: none !important;
}
.common-w {
    width: 250px;
}
.form-upload {
    margin-top: 10px;
}
.quality-item {
    /deep/ .el-form-item {
        margin-bottom: 10px;
    }
}
</style>
